import React from 'react'
import { dispatch } from '@rematch/core';

import { Button, Header, Modal, Grid, Icon, Radio } from 'semantic-ui-react'
import { Form, Dropdown } from 'formsy-semantic-ui-react';
// let Milestone = false;
let teamPathArray = [];
const processTeamData = function (teamNode, teamPath) {
    teamNode.forEach(function (subteam) {
        const updatedTeamPath = <span>{teamPath} <Icon name="chevron right" className="f_12 mar_0 clr-gray" /> {subteam.label}</span>;
        teamPathArray.push(
            {
                _id: subteam._id,
                path: subteam.label,
                text: updatedTeamPath,
                value: subteam._id,
                error: false
            }
        );
        if (subteam.nodes && subteam.nodes.length > 0) {
            processTeamData(subteam.nodes, updatedTeamPath)
        }

    })
}
class AssignCopyAllModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            actionType: 'assign',
            selectedTeam: ''
        }
    }
    handleClose = () => {
        this.props.closeModal();
    }
    componentWillReceiveProps() {
        teamPathArray = [];

        this.props.teams.forEach(function (teamNode) {
            teamPathArray.push({ _id: teamNode._id, path: teamNode.label, text: teamNode.label, value: teamNode._id })
            processTeamData(teamNode.nodes, teamNode.label)
        });
    }
    handleChange = (e, { value }) => {
        this.setState({ actionType: value, selectedTeam: '' })
        if (value === 'copy') {
            if (this.props.selectedOrganisation.role === "workspaceOwner" && this.props.isOrgLevel) {
                teamPathArray.unshift({ _id: "root", path: "root", text: "Workspace", value: "root" })
            }
        }
        else {
            if (teamPathArray[0].value === 'root') {
                teamPathArray.shift();
            }
        }
    }
    completeAction = () => {
        if (this.props.teams.length === 0) {
            this.copyStructure("root");
        }
        else {
            if (this.state.actionType === 'assign') {
                this.assignRolesToTeam(this.props.communities, this.state.selectedTeam)
            }
            else if (this.state.actionType === 'copy') {
                this.copyStructure();
            }
        }
        this.setState({ selectedTeam: '' })

    }
    async assignRolesToTeam() {
        this.props.startProcessing();
        await dispatch.initiatives.assignAllRolesToTeam({ communities: this.props.communities, team: this.state.selectedTeam, initiativeId: this.props.initiativeId });
        dispatch.initiatives.getTeamMappingData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.initiativeId, stopProcessing: this.props.stopProcessing, teamId: this.props.teamId });
        this.props.closeModal();
    }
    setSelectedTeam = (e, data) => {
        this.setState({ selectedTeam: data.value });

    }
    closeModal = () => {
        this.props.closeModal();
        this.setState({ selectedTeam: '' })
    }
    async copyStructure(path) {
        this.props.startProcessing();
        let communitiesArray = [];
        this.props.communities.forEach(community => {
            let communityObject = {
                _id: community._id,
                name: community.name,
                communities: []
            };
            community.communities.forEach(subCommunity => {
                communityObject.communities.push({
                    _id: subCommunity._id,
                    name: subCommunity.name
                })
            })
            communitiesArray.push(communityObject);
        })
        await dispatch.initiatives.copyTeamStructure({ baseTeam: path ? this.props.selectedOrganisation.id : this.state.selectedTeam === 'root' ? this.props.selectedOrganisation.id : this.state.selectedTeam, communities: communitiesArray, initiativeId: this.props.initiativeId, organizationId: this.props.selectedOrganisation.id, accountId: this.props.accountId });
        dispatch.initiatives.getTeamMappingData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.initiativeId, stopProcessing: this.props.stopProcessing, teamId: this.props.teamId });
        this.props.closeModal();
    }
    render() {
        return (
            <Modal
                open={this.props.showAssignCopyAllModal}
                onClose={this.props.closeModal}
                size='small'
                className="basicModal"
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Header content={"Assign / Copy All Roles"} />
                <Form noValidate
                    ref={ref => this.form = ref}
                    id="AssignModalForm"
                    onValidSubmit={(event) => { this.completeAction(event) }}
                >
                    <Modal.Content style={{ padding: "5px 20px" }}>
                        {this.props.teams.length === 0 ? <Grid>
                            <Grid.Row className="pad_0">

                                <p >
                                    There are no teams in your workspace. This will create entire structure in your workspace.

                                    Are you sure you want to copy this role structure to your teams?
                                    </p>

                            </Grid.Row>
                        </Grid> :
                            <Grid>
                                <Grid.Row className="pad_0">
                                    <p >
                                        You already have teams created in your workspace. Please select the team to assign all the roles or you can create exact team structure like playbook roles under selected team.
                                        </p>
                                </Grid.Row>
                                <Grid.Row >
                                    <Radio
                                        label='Assign roles to team ( Default )'
                                        name='radioGroup'
                                        value='assign'
                                        checked={this.state.actionType === 'assign'}
                                        onChange={this.handleChange}
                                    /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <br /><br />
                                    <Radio
                                        label='Create Team structure with auto - mapping ( Advanced Users )'
                                        name='radioGroup'
                                        value='copy'
                                        checked={this.state.actionType === 'copy'}
                                        onChange={this.handleChange}
                                    />
                                </Grid.Row>
                                <Grid.Row >
                                    <div className="display-block w_100" style={{ margin: "0 0 10px 0" }} > Search Team <span style={{ color: '#db2828' }}>*</span> </div><br />
                                    <Dropdown
                                        className="w_100"
                                        name="singleSelectWithDefaultValue"
                                        placeholder="Search Team"
                                        search={(teams, input) => { return teams.filter(team => { return team.path.toLowerCase().includes(input.toLowerCase()) }) }}
                                        selection
                                        fluid
                                        value={this.state.selectedTeam}
                                        options={teamPathArray}
                                        onChange={(e, data) => { this.setSelectedTeam(e, data) }}
                                    />
                                </Grid.Row>

                            </Grid>}

                    </Modal.Content>
                    <Modal.Actions className="actionInFormcy">
                        <Button type="submit" className="button-submit float-right" id='addbtn' disabled={this.props.teams.length !== 0 && !this.state.selectedTeam}>Submit</Button>
                        <Button id='cancelBtn' className="button-cancel" onClick={this.closeModal} type="button"> Cancel</Button>
                    </Modal.Actions>
                </Form>
            </Modal>
        )
    }
}

export default AssignCopyAllModal